import { apiClient } from "../apiClient";

const KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_ENDPOINT = 'khong-du-dieu-kien-hoc-tap-xet-tot-nghiep';
export const khongDuDieuKienKetQuaHocTapXetTotNghiepApi = {
    SelectByDotXet: (id_dot_xet_tot_nghiep: number) => apiClient.get(`${KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_ENDPOINT}/dot-xet/${id_dot_xet_tot_nghiep}`),
}